import enData from "./enData";
import esData from "./esData";

//manipulated esdata for requirement of getting english language values if spanish label is empty

let finalEsData = {};
for (let objkey in esData) {
    for (const key in esData[objkey]) {
        if (esData[objkey][key].trim() == ''|| esData[objkey][key] == null) {
          delete esData[objkey][key];
        }
      }
      finalEsData[objkey] = { ...enData[objkey] ,  ...esData[objkey] };
  }
  
export default {
  en: enData,
  es: finalEsData
};
